import React from 'react';
import { TaskCreateModalProps } from '../type';
import { InvoiceCreateFormContainer } from '../../InvoiceCreateForm';
import { PayBill } from '../../PayBill';
import { Finished } from './Finished';
import ESignature from '../../ESignature';

export const Content = ({
  onClose,
  page,
  setPage,
  open,
  isEditing,
  onSignatureCreated,
  taskDirection,
  createdTask,
  taskType,
  isBinding,
  binding,
}: TaskCreateModalProps) => {
  return React.useMemo(() => {
    switch (page) {
      case 'INVOICE&QUOTES':
        return <InvoiceCreateFormContainer />;
      case 'PAY_BILL':
        return <PayBill onClose={onClose} />;
      case 'E_SIGNATURE':
        return (
          <ESignature onComplete={onSignatureCreated} taskType={taskType} />
        );
      case 'FINISH':
        return (
          <Finished
            onClose={onClose}
            page={page}
            setPage={setPage}
            open={open}
            isEditing={isEditing}
            onSignatureCreated={onSignatureCreated}
            taskDirection={taskDirection}
            createdTask={createdTask}
            taskType={taskType}
            isBinding={isBinding}
            binding={binding}
          />
        );
    }
  }, [
    page,
    onSignatureCreated,
    setPage,
    taskDirection,
    createdTask,
    taskType,
    isBinding,
    binding,
  ]);
};
